import React from "react";

import AutocompleteSelectInput from "veneer/AutocompleteSelectInput";

import { Filter, USER_ROLES, UserRoleOption } from "cortex/ui/src/user/model";

interface UserListFiltersProps {
  onChange: (newValue: Filter) => void;
  value: Filter;
}

export default function UserListFilters({
  onChange,
  value,
}: UserListFiltersProps) {
  return (
    <AutocompleteSelectInput
      getOptionLabel={(opt) => opt.label}
      inputProps={{ label: "Access Level", sx: { minWidth: 200 } }}
      isOptionEqualToValue={(opt, val) => opt.value === val.value}
      multiple
      onChange={(_e, option: ReadonlyArray<UserRoleOption> | null) =>
        onChange({
          ...value,
          roles: option ? option.map((opt) => opt.value) : [],
        })
      }
      options={USER_ROLES}
      size="small"
      value={USER_ROLES.filter((option) =>
        (value.roles ?? []).includes(option.value),
      )}
    />
  );
}
